/* eslint-disable custom-import/dynamic-import-chunkname */
import { withTheme } from 'react-jss';
import React from 'react';
import PropTypes from 'prop-types';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

export function withDelayedStyles(WrappedComponent, getDefaultStyles, getStyles, eventName) {
  class HOC extends React.PureComponent {
    constructor(props) {
      super(props);
      this.styleSheet = null;
      this.state = {
        classes: null,
      };
    }

    componentDidMount() {
      if (eventName) {
        eventDispatcher.once(eventName, () => {
          if (!this.styleSheet || this.styleSheet.attached === false) {
            Promise.all([
              import('react-jss'),
              getStyles(),
            ]).then(([{ jss }, { getDelayedStyles }]) => {
              const { theme } = this.props;
              const styles = getDelayedStyles(theme.component, theme.core);
              this.styleSheet = jss.createStyleSheet(styles).attach();
              this.setState({ classes: this.styleSheet.classes });
            });
          }
        });
      }
    }

    componentWillUnmount() {
      if (this.styleSheet) {
        this.styleSheet.detach();
      }
    }

    render() {
      if (this.state.classes) {
        return (
          <WrappedComponent {...this.props} classes={this.state.classes} />);
      }

      return (
        <WrappedComponent {...this.props} />);
    }
  }

  HOC.propTypes = {
    theme: PropTypes.shape({}).isRequired,
  };

  return withDefaultStyles(withTheme(HOC), getDefaultStyles);
}
